import { Skeleton } from '@/components/ui/skeleton';

const COMMODITY_ORIGIN_SKELETON_KEYS = [
  'commodity-origin-card-skeleton-1',
  'commodity-origin-card-skeleton-2',
  'commodity-origin-card-skeleton-3',
] as const;

export function ProductionDeclarationMaterialCommodityOriginsLoadingState() {
  return (
    <div className='space-y-7'>
      <div className='rounded-[1.4rem] border border-declaration-border bg-white px-7 py-6 shadow-[0_10px_24px_rgba(17,24,39,0.06)] sm:px-8'>
        <div className='flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between'>
          <Skeleton className='h-6 w-full max-w-[32rem] rounded-full bg-declaration-skeleton' />
          <Skeleton className='h-11 w-[14rem] rounded-lg bg-declaration-skeleton' />
        </div>
      </div>

      <div className='space-y-5'>
        <Skeleton className='h-8 w-[14rem] rounded-full bg-declaration-skeleton' />
        {COMMODITY_ORIGIN_SKELETON_KEYS.map((skeletonKey) => (
          <div
            className='rounded-[1.4rem] border border-declaration-border bg-white px-7 py-8 shadow-[0_10px_24px_rgba(17,24,39,0.06)] sm:px-8'
            key={skeletonKey}
          >
            <div className='flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between'>
              <div className='w-full space-y-5'>
                <Skeleton className='h-6 w-[15rem] rounded-full bg-declaration-skeleton' />
                <Skeleton className='h-5 w-full max-w-[28rem] rounded-full bg-declaration-skeleton' />
              </div>
              <Skeleton className='h-11 w-[13rem] rounded-lg bg-declaration-skeleton' />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
